import { Button } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import KeywordAsyncSelect from "./keyword-async-select";
import { useDialog } from "../../../../hooks/useDialog";
import { useTranslation } from "react-i18next";

const DynamicFieldKeywordRow = ({ field }) => {
  const {
    name,
    index,
    error,
    placeholder,
    isGenerated,
    onAfterDelete,
    removeHandler,
    excludeIds = []
  } = field;

  const { t } = useTranslation();
  const { control } = useFormContext();
  const { showConfirmationDialogBox } = useDialog();

  const handleDeleteClick = () => {
    if (isGenerated) {
      showConfirmationDialogBox({
        dialogType: "danger",
        title: t("localSeo.delDialogHeading"),
        dialogMessage: (
          <div
            dangerouslySetInnerHTML={{
              __html: t("localSeo.deleteGeneratedFieldMsg")
            }}
          />
        ),
        responseAction: (confirmed) => {
          if (confirmed && onAfterDelete) onAfterDelete();
        }
      });
    } else {
      removeHandler(index);
    }
  };

  return (
    <>
      <div className="w-25">
        <KeywordAsyncSelect
          name={`${name}.${index}.value`}
          control={control}
          placeholder={placeholder}
          isDisabled={isGenerated}
          fieldError={!!error}
          excludeIds={excludeIds}
        />
      </div>
      <div className="ms-3">
        <div className="d-flex">
          <Button variant="outline-danger" onClick={handleDeleteClick}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </Button>
        </div>
      </div>
    </>
  );
};

export default DynamicFieldKeywordRow;
